module.exports = __webpack_public_path__ + "img/zoom-in.8e8ea955.svg";